// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3tXXL","right":"Footer_right__31q8N","buttons":"Footer_buttons__OpeH8"};